import {Injectable} from "@angular/core";
import {Observable, throwError} from "rxjs";
import {of} from "rxjs/internal/observable/of";
import {catchError, switchMap, tap} from "rxjs/operators";
import {ExecutionResultModel} from "../../models/api/execution-result.model";
import {NotificationService} from "../components/notification.service";

@Injectable({
    providedIn: "root"
})
export class ApiResultDispatcherService {
    private get DEFAULT_ERROR_MESSAGE(): string {
        return "An error has occurred. Please try again or contact the system administrator if the problem persists.";
    }

    public constructor(
        private notificationService: NotificationService
    ) {

    }

    public dispatchNetworkErrorNotification<TResult>(http: Observable<TResult>): Observable<TResult> {
        return http
            .pipe(
                catchError(err => {
                    this.notificationService.showError("", this.DEFAULT_ERROR_MESSAGE);
                    return throwError(err);
                })
            );
    }

    public dispatchApiResultErrorNotification<TResult>(http: Observable<ExecutionResultModel<TResult>>): Observable<ExecutionResultModel<TResult>> {
        return this.dispatchNetworkErrorNotification(http)
            .pipe(
                tap(result => {
                    if (!result.success) {
                        const errors = result.errors.map(x => x.message);
                        if (!errors.length) {
                            errors.push(this.DEFAULT_ERROR_MESSAGE);
                        }
                        this.notificationService.showError("", errors.join("<br/>"));
                    }
                })
            );
    }

    public unwrapExecutionResult<TResult>(http: Observable<ExecutionResultModel<TResult>>): Observable<TResult> {
        return http
            .pipe(
                switchMap(result => {
                    if (!result.success) {
                        return throwError(result.errors);
                    }
                    return of(result.value);
                })
            );
    }

    public dispatchErrorsAndUnwrapResult<TResult>(http: Observable<ExecutionResultModel<TResult>>): Observable<TResult> {
        http = this.dispatchApiResultErrorNotification(http);

        return this.unwrapExecutionResult(http);
    }
}
